// For GDPR compliance it is important that we allow users to see all the MRU entries they have created.
// MRU service has a limit of 250 MRU entries per App (not currently enforced) and 1000 MRU entries per user (currently enforced).
// Query all 1000 entries to be GDPR compliant.
export const MaxMruCount = 1000;
/**
 * Required headers for Mru service
 */ export var MruHeaders = /*#__PURE__*/ function(MruHeaders) {
    MruHeaders["OfficePlatform"] = "X-Office-Platform";
    MruHeaders["OfficeApplication"] = "X-Office-Application";
    MruHeaders["OfficeVersion"] = "X-Office-Version";
    return MruHeaders;
}({});
/**
 * Response headers from the MRU service that are useful for diagnostics
 */ export var MruResponseHeaders = /*#__PURE__*/ function(MruResponseHeaders) {
    MruResponseHeaders["CorrelationId"] = "X-Correlationid";
    return MruResponseHeaders;
}({});
/**
 * Fallback minimum OCS server-side duration (`diagnostics_data.total_duration`, in ms) at or above which
 * we log the MRU upsert server diagnostics (subsystem timing breakdown, datacenter/front-end/build).
 * Used only when the ECS-tunable `serviceConfigurations.mru.slowUpsertDiagnosticsThresholdMs` is absent.
 * Gates the diagnostics log to the slow tail so we don't flood telemetry on the high volume of fast
 * upserts while still capturing the slowest successful OCS responses.
 */ export const DefaultMruSlowUpsertDiagnosticsThresholdMs = 30000;
